import type { PropsWithChildren } from 'react';
import { useRef } from 'react';
import type { AriaModalOverlayProps } from 'react-aria';
import { Overlay, useModalOverlay } from 'react-aria';
import type { OverlayTriggerState } from 'react-stately';

import Motion from '@/app/components/Motion';

export interface ModalProps extends AriaModalOverlayProps, PropsWithChildren {
  readonly state: OverlayTriggerState;
}

const Modal = ({ children, state, ...props }: ModalProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const { modalProps, underlayProps } = useModalOverlay(props, state, ref);

  return (
    <Overlay>
      <Motion
        animate={{ opacity: 1 }}
        className="fixed inset-0 z-100"
        initial={{ opacity: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.333, type: 'tween' }}
      >
        <div
          {...underlayProps}
          className="size-full"
          data-cy="leadership_profile_modal"
        >
          <div {...modalProps} className="size-full" ref={ref}>
            {children}
          </div>
        </div>
      </Motion>
    </Overlay>
  );
};

export default Modal;
